import { Add, Circle, DeleteOutlineOutlined, Edit, Search, Tune } from '@mui/icons-material'
import { Autocomplete, Checkbox, ClickAwayListener, FormControl, FormControlLabel, FormGroup, IconButton, MenuItem, Paper, Popper, Select, Switch, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import { EyeOutlined } from '@ant-design/icons';
import { DataGrid } from '@mui/x-data-grid';
import { Modal, ProgressBar } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { newHost } from '../Categories/CategoryProfile';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DeleteModal from '../../components/Modals/DeleteModal';
import { set } from 'lodash';
import { useLocation } from 'react-router';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
const NotificationCampaigns = () => {
    const { user } = useSelector((state) => state.auth);

        const location = useLocation();
    
    const token = user?.token;
    const [anchorEl, setAnchorEl] = useState(null);
    const [campaignsShow, setCampaignsShow] = useState(false)
    const [campaignsDetailsShow, setCampaignDetailsShow] = useState(false)
    const [inputRadioName, setInputRadioName] = useState(null)
    const [campaigns, setcampaigns] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [campaignStatus, setCampaignsStatus] = useState([]);
    const [targetRules, setTargetRules] = useState([])
    const [userGroups, setUserGroups] = useState([])
    const [deleteShow, setDeleteShow] = useState(false)
    const [campaignId, setCampaignId] = useState("")
    const [isExecute, setIsExecute] = useState(false)
    const [campaignsData, setCampaignsData] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);      
    const [statusFilters, setStatusFilters] = useState([]); 
    const [searchText, setSearchText] = useState("");
    const [isScheduled, setIsScheduled] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);


    const ActivateChange = (switched, campaign) => {
        console.log(campaign);
        setShowActivate(true)
        setCampaignId(campaign.id)
        setCampaignsData(campaign)
        if (switched) {
            setIsExecute(true)
        }
        else {
            setIsExecute(false)
        }
    }
    const columns = [
        {
            field: "name",
            headerName: "Name",
            flex: 0.9,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <p className="m-0">{params.row.name}</p>
                )
            }
        },
        {
            field: "template",
            headerName: "Template",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.template?.name}
                    </div>
                )
            }
        },
        {
            field: "targeting_rule",
            headerName: "Target",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.targeting_rule?params.row.targeting_rule?.name :"No available Target Rule"}
                    </div>
                )
            }

        },
        {
            field: "channels",
            headerName: "Channels",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => {
                return (
                    <div className='d-flex justify-content-center align-items-center  gap-2'>
                        {params.row.channels.map((channel) =>
                            <p className=' channels-campaingns-table'> {channel}
                            </p>

                        )}
                    </div>
                )
            }
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.9,
            minWidth: 110,
            renderCell : (params)=>{
                return(
                    <div className='d-flex align-items-center justify-content-center gap-2'>
                             <CircleIcon sx={{ color: params.row.status == "completed" ? "#8CB369" 
                                            : params.row.status == "draft" ? "#D9D9D9" 
                                            : params.row.status == "processing" ? "#3E9FF6"
                                            : params.row.status == "scheduled" ? "#FEB91E" 
                                            : params.row.status == "failed" ? "#FC6C4F" 
                                            : "transparent", fontSize: 10 }} />
                                            <p className='m-0'>{params.row.status}</p>
                    </div>
                )
            }
        },
        {
            field: "progress",
            headerName: "Progress",
            flex: 0.8,
            minWidth: 110,
            renderCell: (params) => {
                const progress = parseFloat(params.row.progress);

                let bgColor = "#ccc";
                if (progress <= 30) bgColor = "#ffeb3b";
                else if (progress <= 70) bgColor = "#3E9FF6";
                else bgColor = "#8CB369";

                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <div
                            style={{
                                height: "6px",
                                width: "75%",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "6px",
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    width: `${progress}%`,
                                    height: "100%",
                                    backgroundColor: bgColor,
                                    transition: "width 0.3s ease",
                                }}
                            />
                        </div>
                    </div>
                );
            },
        },
        {
            field: "started_at",
            headerName: "Start Date",
            flex: 0.8,
            minWidth: 110,
            renderCell: (params) => {
                return (
                    <div>
                        {new Date(params.row.started_at)?.toLocaleDateString()}
                    </div>
                )
            }

        },

        {
            field: "Actions",
            headerName: "Actions",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className='d-flex justify-content-evenly align-items-center h-100 w-100'>
                        <IconButton
                            onClick={(e) => handleCampaignDetailsShow(e, params.row)}
                            sx={{ color: "black", }}
                            aria-label="Preview"
                            size="small"
                           style={{ width: "25%" }}


                        >
                            <EyeOutlined />
                        </IconButton>
                     
                        <div
  onClick={(e) => {
    e.stopPropagation();
    if (["processing", "completed"].includes(params.row.status)) {
      toast.warning("Please! cancel this campaign before updating");
      return;
    }
    handleUpdateCampaignsShow(e, params.row);
  }}
  style={{ display: "inline-block" }}
>
  <IconButton
    color="default"
    aria-label="edit"
    size="small"
    disabled={["processing", "completed"].includes(params.row.status)}
    style={{ width: "25%" }}

  >
    <Edit />
  </IconButton>
</div>

                        <IconButton
                            onClick={(e) => e.stopPropagation()}
                            aria-label="switch"
                            size="small"
                            style={{ width: "25%" }}

                        >
                            <Switch
                                checked={["processing", "completed"].includes(params.row.status)}

                                onChange={(e) => ActivateChange(e.target.checked, params.row)} color="success" sx={{ width: 53 }} />
                        </IconButton>
                    
                                             <div
  onClick={(e) => {
    e.stopPropagation();
    if (["processing", "completed"].includes(params.row.status)) {
      toast.warning("Please! cancel this campaign before deleting");
      return;
    }
     handleDeleteShow(e, params.row?.id)
  }}
  style={{ display: "inline-block" }}
>
  <IconButton
    color="error"
    aria-label="delete"
    size="small"
    disabled={["processing", "completed"].includes(params.row.status)}
    style={{ width: "25%" }}

  >
    <DeleteOutlineOutlined />
  </IconButton>
</div>
                    </div>
                );
            },
        },
    ];
  
    const paginationModel = { page: 0, pageSize: 10 };
    const {
        register,
        handleSubmit,
        setValue,
        control,
        reset,
        watch,
        formState: { errors },
    } = useForm(
        {
            defaultValues: {
                name: "",
                description: "",
                template_id: "",
                user_group_id: "",
                targeting_rule_id: "",
                status: "",
                channels: [],
            },
        }
    )
    const channelOptions = ["email", "sms", "fcm", "database"];

    
    const selectedChannels = watch("channels") || [];


    const toggleChannel = (channel) => {
        const updated = selectedChannels.includes(channel)
            ? selectedChannels.filter((c) => c !== channel)
            : [...selectedChannels, channel];

        setValue("channels", updated, { shouldValidate: true });
    };
    const handleCampaignsShow = () => {
        setCampaignsShow(true)
        setIsEdit(false)
    }
    const handleCampaignsClose = () => {
        setCampaignsShow(false)
        reset()
        setInputRadioName(null)
        setIsScheduled(false)
    }
    const handleUpdateCampaignsShow = (e, campaign) => {
        e.stopPropagation()
        setCampaignsShow(true)
        setCampaignId(campaign.id)
        setIsEdit(true)
        setValue("name", campaign.name)
        setValue("description", campaign.description)
        setValue("template_id", campaign.template_id)
        if(campaign.status == "scheduled"){
            setIsScheduled(true)
      setValue("scheduled_at", campaign.scheduled_at ? dayjs(campaign.scheduled_at) : null);

        }else{
         setIsScheduled(false)

        }
        setValue("status", campaign.status || "")

        if (campaign.targeting_rule_id) {
            setInputRadioName("targeting-rule");
            setValue("targeting_rule_id", campaign.targeting_rule_id);
        } else {
            setInputRadioName("user-group");
            setValue("user_group_id", campaign.user_group_id);
        }

        setValue("channels", campaign.channels || [], { shouldValidate: true });

    }

    const handleCampaignDetailsShow = async (e, campaign) => {
        setCampaignDetailsShow(true)
        e.stopPropagation()
        try {
            const response = await axios.get(`${newHost}portal/notification-campaigns/${campaign.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(response);

            setCampaignsData(response.data.data.campaign)
        } catch (error) {
            console.log(error);

        }
    }
    const handleCampaignDetailsClose = () => {
        setCampaignDetailsShow(false)
        setCampaignsData({})

    }
    const [showActivate, setShowActivate] = useState(false);

    
    const handleActivateClose = () => {
        setShowActivate(false);
    };
    const handleDeleteShow = (e, id) => {
        setDeleteShow(true)
        setCampaignId(id)
        e.stopPropagation()
    }
    const handleDeleteClose = () => {
        setDeleteShow(false)
    }
    const TargetingChange = (target) => {
        setInputRadioName(target.id);

        if (target.id === "user-group") {
            setValue("targeting_rule_id", "");
        } else {
            setValue("user_group_id", "");
        }
    };

    const getAllcampaigns = async () => {
        try {
            const response = await axios.get(`${newHost}portal/notification-campaigns`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(response);

            setcampaigns(response.data.data.campaigns.data)
            setFilteredCampaigns(response.data.data.campaigns.data)
        } catch (error) {
            console.log(error);

        }
    }
    const getTemplates = async () => {
        try {
            const response = await axios.get(`${newHost}portal/notification-templates`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(response);
            setTemplates(response.data.data.templates)
        } catch (error) {
            console.log(error);

        }
    }
    const getCampaignsStatus = async () => {
        try {
            const response = await axios.get(`${newHost}portal/notification-campaigns/statuses`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(response);
            setCampaignsStatus(response.data.data.allowed_for_creation)
        } catch (error) {
            console.log(error);

        }
    }
    const getAllTargetRules = async () => {
        try {
            const response = await axios.get(`${newHost}portal/targeting-rules`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            console.log(response);
            setTargetRules(response.data.data?.targeting_rules?.data)
        } catch (error) {
            console.log(error);

        }
    }
    const getAllUserGroups = async () => {
        try {
            const response = await axios.get(`${newHost}portal/user-groups`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            console.log(response);
            setUserGroups(response.data.data?.user_groups?.data)
        } catch (error) {
            console.log(error);

        }
    }
    const submitCampaigns = async (data) => {
        console.log(data);
        if (isEdit) {
            try {
                const response = await axios.post(`${newHost}portal/notification-campaigns/${campaignId}`,
                    {
                        ...data,
                        _method: "PATCH"
                    }

                    , {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                console.log(response);
                toast.success(response.data.message)
                setCampaignsShow(false)
                getAllcampaigns()
                reset()
                setInputRadioName(null)
                setIsScheduled(false)
            } catch (error) {
                toast.error(error.response.data.message)
            }
        } else {
            try {
                const response = await axios.post(`${newHost}portal/notification-campaigns`,
                    data

                    , {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                console.log(response);
                toast.success(response.data.message)
                setCampaignsShow(false)
                getAllcampaigns()
                reset()
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }

    }
    const handleCampaignsDelete = async () => {
        try {
            const response = await axios.delete(`${newHost}portal/notification-campaigns/${campaignId}`, {
                headers: { Authorization: `Bearer ${token}` }

            })
            toast.success(response.data?.data?.message)
            setDeleteShow(false)
            getAllcampaigns()

        } catch (error) {
            console.log(error);
            toast.error(error.response.message)
        }
    }
    const handleCampaignsSwitch = async () => {
        try {
            const response = await axios.post(`${newHost}portal/notification-campaigns/${campaignId}/${isExecute ? "execute" : "cancel"}`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            })
            console.log(response);
            toast.success(response.data.data.message)
            getAllcampaigns()
            setShowActivate(false)

        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
      const handleStatusToggle = (status) => {
    
  setStatusFilters((prev) =>
    
    prev.includes(status)
      ? prev.filter((s) => s !== status)
      : [...prev, status]
  );
};
const handleStatusField = (status)=>{
    console.log(status);
    
if(status == "scheduled"){
    setIsScheduled(true)
}else{
    setIsScheduled(false)
}

}

useEffect(() => {
  let filtered = [...campaigns];

  if (statusFilters.length > 0) {
    filtered = filtered.filter(campaign =>
      (statusFilters.includes("Completed") && campaign.status === "completed") ||
      (statusFilters.includes("Draft") && campaign.status === "draft") ||
      (statusFilters.includes("Processing") && campaign.status === "processing") ||
      (statusFilters.includes("Scheduled") && campaign.status === "scheduled") ||
      (statusFilters.includes("Failed") && campaign.status === "failed") ||
      (statusFilters.includes("Cancelled") && campaign.status === "cancelled")
    );
  }

  if (searchText.trim() !== "") {
    filtered = filtered.filter(campaign =>
      campaign.name?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  setFilteredCampaigns(filtered);
}, [statusFilters, campaigns, searchText]);

    useEffect(() => {
        getAllcampaigns()
        getTemplates()
        getCampaignsStatus()
        getAllTargetRules()
        getAllUserGroups()
    }, [])

        useEffect(() => {
          if (location.state?.openModal) {
            handleCampaignsShow();
          }
        }, [location.state]);
    

    return (
        <>
            <DeleteModal
                showDelete={deleteShow}
                handleDeleteClose={handleDeleteClose}
                textMessage={" Are you sure you want to delete this Campaigns?"}
                deleteFunction={handleCampaignsDelete}
            />
            <Modal show={campaignsShow} onHide={handleCampaignsClose} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
                    <Modal.Title style={{ fontSize: 25 }}>
                        {isEdit ? "Update Campaigns" : "Create New Campaign"}

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(submitCampaigns)}>
                        <div className="my-2">
                            <label htmlFor="">Campaign Name *</label>
                            <TextField
                            size='small'
                                style={{ outlineColor: "black", }}
                                className='w-100 ' type='text' placeholder='Add Campaign Name'
                                {...register("name")}
                            />
                        </div>
                        <div className="my-2">
                            <label htmlFor="">Description</label>
                            <textarea style={{ padding: 10, borderRadius: 15, border: "solid 2px #D8D8D8", }} rows={3} className='w-100' type='text' placeholder='Enter Campaign description'
                                {...register("description")}

                            />
                        </div>


                        <div className="row my-2">
                            <div className="col-md-6 col-sm-12">
                                <label htmlFor="">Template *</label>
                                <Controller
                                    name="template_id"
                                    control={control}
                                       render={({ field }) => {
                                                                      const options = templates.map(option => ({
                                                                        label: option.name,
                                                                        id: option.id,
                                                                      }));
                                                
                                                                      return (
                                                                        <Autocomplete
                                                                          size="small"
                                                                          options={options}
                                                                          value={options.find(opt => opt.id == field.value) || null}
                                                
                                                                          onChange={(e, item) => {
                                                                            field.onChange(item ? item.id : null);
                                                                          }}
                                                
                                                                          renderOption={(props, option) => (
                                                                            <li {...props} className="p-2">
                                                                              {option.label}
                                                                            </li>
                                                                          )}
                                                
                                                                          renderInput={(params) => (
                                                                            <TextField {...params} placeholder="Select Template" />
                                                                          )}
                                                                        />
                                                                      );
                                                                    }}
                                    // render={({ field }) => (
                                    //     <FormControl className="w-100" variant="outlined">
                                    //         <Select


                                    //             label=""
                                    //             labelId=''
                                    //             value={field.value || ""}
                                    //             onChange={(e) => field.onChange(e.target.value)
                                    //             }
                                    //         >
                                    //             {templates.map((template) => (
                                    //                 <MenuItem
                                    //                     value={template.id}
                                    //                     className="custom-menu-item "

                                    //                 >
                                    //                     <div className='label-size m-0'>                            {template.name}
                                    //                     </div>
                                    //                 </MenuItem>
                                    //             ))}
                                    //         </Select>
                                    //     </FormControl>
                                    // )}
                                />
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <label htmlFor="">Status *</label>

                                <Controller
                                    name="status"
                                    control={control}
   render={({ field }) => {
                                                                      const options = campaignStatus.map(option => ({
                                                                        label: option.label,
                                                                        id: option.value,
                                                                      }));
                                                
                                                                      return (
                                                                        <Autocomplete
                                                                          size="small"
                                                                          options={options}
                                                                          value={options.find(opt => opt.id == field.value) || null}
                                                
                                                                          onChange={(e, item) => {
                                                                            field.onChange(item ? item.id : null);
                                                                             handleStatusField(item.id)
                                                                          }}
                                                
                                                                          renderOption={(props, option) => (
                                                                            <li {...props} className="p-2">
                                                                              {option.label}
                                                                            </li>
                                                                          )}
                                                
                                                                          renderInput={(params) => (
                                                                            <TextField {...params} placeholder="Select Status" />
                                                                          )}
                                                                        />
                                                                      );
                                                                    }}
                                    // render={({ field }) => (
                                    //     <FormControl className="w-100" variant="outlined">

                                    //         <Select


                                    //             label=""
                                    //             labelId=''
                                    //             value={field.value || ""}
                                    //             onChange={(e) => {field.onChange(e.target.value)
                                    //              handleStatusField (e.target.value)
                                                    
                                    //             }
                                    //             }
                                    //         >


                                    //             {campaignStatus.map((status) => (

                                    //                 <MenuItem
                                    //                     key={status.value}
                                    //                     value={status.value}
                                    //                     className="custom-menu-item "
                                                    
                                    //                 >
                                    //                     <div className='label-size m-0'>                            {status.label}
                                    //                     </div>
                                    //                 </MenuItem>
                                    //             ))}
                                    //         </Select>
                                    //     </FormControl>

                                    // )}
                                />

                            </div>
                        </div>
                        {isScheduled&& <div className='w-100'>
                      
                <LocalizationProvider dateAdapter={AdapterDayjs}>
             <DemoContainer components={["DatePicker"]} sx={{ width: "100%" }}>
          <Controller
            name="scheduled_at"
            control={control}
            render={({ field }) => (
              <DatePicker
               slotProps={{ textField: { size: 'small' } }}
                {...field}
                label="Scheduled At"
                value={field.value}
                onChange={(date) => field.onChange(date)
                    
                }
                
              />
            )}
          />
        </DemoContainer>
      </LocalizationProvider>

                        </div> }
                        
                        <div className="my-3">
                            <label htmlFor="">Targeting *</label>
                            <div className='d-flex gap-4 my-1'>

                               
                                <div className='d-flex gap-1 align-items-center'>
                                    <input
                                        onChange={(e) => TargetingChange(e.target)}
                                        id="user-group"
                                        type="radio"
                                        name='Targeting'
                                        checked={inputRadioName === "user-group"}
                                    />
                                    <label className='label-size' htmlFor="user-group">User Group</label>
                                </div>

                                <div className='d-flex gap-1 align-items-center'>
                                    <input
                                        onChange={(e) => TargetingChange(e.target)}
                                        id="targeting-rule"
                                        type="radio"
                                        name='Targeting'
                                        checked={inputRadioName === "targeting-rule"} 
                                    />
                                    <label className='label-size' htmlFor="targeting-rule">Targeting Rule</label>
                                </div>

                            </div>
                        </div>
                        {inputRadioName == "user-group" ? <div className="">
                            <Controller
                                name="user_group_id"
                                control={control}
                                   render={({ field }) => {
                                                                      const options = userGroups.map(option => ({
                                                                        label: option.name,
                                                                        id: option.id,
                                                                      }));
                                                
                                                                      return (
                                                                        <Autocomplete
                                                                          size="small"
                                                                          options={options}
                                                                          value={options.find(opt => opt.id == field.value) || null}
                                                
                                                                          onChange={(e, item) => {
                                                                            field.onChange(item ? item.id : null);
                                                                          }}
                                                
                                                                          renderOption={(props, option) => (
                                                                            <li {...props} className="p-2">
                                                                              {option.label}
                                                                            </li>
                                                                          )}
                                                
                                                                          renderInput={(params) => (
                                                                            <TextField {...params} placeholder="Select User Group" />
                                                                          )}
                                                                        />
                                                                      );
                                                                    }}
                                // render={({ field }) => (
                                //     <FormControl className="w-100" variant="outlined">
                                //         <Select
                                //             MenuProps={{
                                //                 PaperProps: {
                                //                     style: {
                                //                         maxHeight: 200,
                                //                         overflowY: "scroll",
                                //                         // width: "auto",
                                //                     },
                                //                 },
                                //             }}
                                //             label=""
                                //             labelId=''
                                //             value={field.value || ""}
                                //             onChange={(e) => field.onChange(e.target.value)
                                //             }
                                //         >
                                //             {userGroups.map((group) => (
                                //                 <MenuItem
                                //                                                                                                                     value={group.id}
                                //                     className="custom-menu-item "

                                //                 >
                                //                     <div className='label-size m-0'>                            {group.name}
                                //                     </div>
                                //                 </MenuItem>
                                //             ))}
                                //         </Select>
                                //     </FormControl>
                                // )}
                            />
                        </div > : inputRadioName == "targeting-rule" ? <Controller
                            name="targeting_rule_id"
                            control={control}
                               render={({ field }) => {
                                                                      const options = targetRules.map(option => ({
                                                                        label: option.name,
                                                                        id: option.id,
                                                                      }));
                                                
                                                                      return (
                                                                        <Autocomplete
                                                                          size="small"
                                                                          options={options}
                                                                          value={options.find(opt => opt.id == field.value) || null}
                                                
                                                                          onChange={(e, item) => {
                                                                            field.onChange(item ? item.id : null);
                                                                          }}
                                                
                                                                          renderOption={(props, option) => (
                                                                            <li {...props} className="p-2">
                                                                              {option.label}
                                                                            </li>
                                                                          )}
                                                
                                                                          renderInput={(params) => (
                                                                            <TextField {...params} placeholder="Select Rule" />
                                                                          )}
                                                                        />
                                                                      );
                                                                    }}
                            // render={({ field }) => (
                            //     <FormControl className="w-100" variant="outlined">
                            //         <Select
                            //             MenuProps={{
                            //                 PaperProps: {
                            //                     style: {
                            //                         maxHeight: 200,
                            //                         overflowY: "scroll",
                            //                     },
                            //                 },
                            //             }}

                            //             label=""
                            //             labelId=''
                            //             value={field.value || ""}
                            //             onChange={(e) => field.onChange(e.target.value)
                            //             }
                            //         >
                            //             {targetRules.map((rule) => (
                            //                 <MenuItem
                            //                     value={rule.id}
                            //                     className="custom-menu-item "

                            //                 >
                            //                     <div className='label-size m-0'>                            {rule.name}
                            //                     </div>
                            //                 </MenuItem>
                            //             ))}
                            //         </Select>
                            //     </FormControl>
                            // )}
                        /> : null}



                        
                        <div className="my-1">
                            <label className="" htmlFor="">
                                Channels *
                            </label>

                            <input type="hidden" {...register("channels")} />

                            <div className="d-flex align-items-start gap-4 mx-2  flex-wrap">
                                {channelOptions.map((channel) => (
                                    <div key={channel} className="d-flex gap-1 align-items-center">
                                        <input
                                        id={channel}
                                            type="checkbox"
                                            className=""
                                            checked={selectedChannels?.includes(channel)}
                                            onChange={() => toggleChannel(channel)}
                                        />
                                        <label htmlFor={channel} className="label-size">{channel}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="d-flex gap-4 justify-content-center align-items-center  py-4">

                            <button type='reset' className='px-5 py-2 btn btn-light' onClick={handleCampaignsClose}>
                                Cancel
                            </button>
                            <button className='px-5 py-2 btn btn-dark' >
                                Save
                            </button>
                        </div>
                    </form>

                </Modal.Body>

            </Modal>
            <Modal show={campaignsDetailsShow} onHide={handleCampaignDetailsClose} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
                    <Modal.Title style={{ fontSize: 25 }}>
                        Campaign Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-3 text-center-responsive">
                        <h5 className="fw-semibold font-size-large">Summer Sale</h5>
                        <div className="row ">
                            <div className="col-md-6 col-sm-12">
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Status</h6>
                                    <div className="d-flex align-items-center gap-2 status-responsive">
                                        <CircleIcon sx={{ color: campaignsData?.status == "completed" ? "#8CB369" 
                                            : campaignsData?.status == "draft" ? "#D9D9D9" 
                                            : campaignsData?.status == "processing" ? "#3E9FF6"
                                            : campaignsData?.status == "scheduled" ? "#FEB91E" 
                                            : campaignsData?.status == "failed" ? "#FC6C4F" 
                                            : "transparent", fontSize: 10,  }} />
                                        <h6 className='label-size m-0 font-size-large'>{campaignsData?.status}</h6>
                                    </div> </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Template</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{campaignsData?.template?.name}</h6>
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Channels</h6>
                                    <div className="d-flex gap-2 flex-wrap align-items-center status-responsive">
                                        {campaignsData?.channels?.map((channel)=>
                                     <h6 className='label-size m-0 fw-semibold campaigns-channels font-size-large'>{channel}</h6>

                                    )}
                                    </div>
                                    
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Started</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{new Date (campaignsData?.started_at)?.toLocaleDateString()}</h6>
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Recipients</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{`${campaignsData?.user_group?campaignsData?.user_group?.user_count : "No"} users`}  </h6>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Progress</h6>
                                  
                       <div className=" d-flex status-responsive">
                                         <div
                                         className='status-responsive'
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "70%",
                            height: "100%",
                        }}
                    >
                        <div
                            style={{
                                height: "6px",
                                width: "75%",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "6px",
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    width: `${parseFloat(campaignsData.progress)}%`,
                                    height: "100%",
                                    backgroundColor: campaignsData.progress <= 30? "#ffeb3b": campaignsData.progress <= 70? "#3E9FF6": campaignsData.progress > 70? "#8CB369":  "transparent" ,
                                    transition: "width 0.3s ease",
                                }}
                            />
                        </div>
                    </div>
                       </div>
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label my-2 font-size-large">Target</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{`${campaignsData?.targeting_rule? campaignsData?.targeting_rule?.name : "No Target"} `}</h6>
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Scheduled</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{new Date (campaignsData?.scheduled_at)?.toLocaleDateString()}</h6>
                                </div>
                                <div className="my-4">
                                    <h6 className="campaigns-details-label font-size-large">Completed</h6>
                                    <h6 className='label-size m-0 fw-semibold font-size-large'>{new Date (campaignsData?.completed_at)?.toLocaleDateString()}</h6>
                                </div>
                            </div>
                        </div>
                        <div className="my-4">
                            <h6 className="label-size fw-semibold font-size-large">Preview</h6>
                            <div className="border rounded-3 bg-light p-3">
                                <div className="border rounded-3 py-2 px-3">
                                    <h6 className="spplier-profile-label-color fw-bold font-size-large">{campaignsData?.template?.title}</h6>
                                    <h6 className="spplier-profile-label-color font-size-large">{campaignsData?.template?.body}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>

            </Modal>
            <Modal show={showActivate} onHide={handleActivateClose} className="">
                <>
                    <div className="text-center py-4">
                        {" "}
                        <h3>
                            {isExecute ? "Execute Campaign Now" : "Cancel Campaign"}
                        </h3>
                    </div>

                    <div className="text-center py-2  px-3">
                        <h6 className="fs-5 spplier-profile-label-color">
                            Are you sure you want to {isExecute ? "execute" : "cancel"} this campaign?
                            <br />
                            You're {isExecute ? "excuting" : "cancelling"} {`${campaignsData.name}`}.
                            <br />
                            Current progress: {`${parseFloat(campaignsData.progress)}%`}
                        </h6>
                    </div>
                    <div>
                        <div className="d-flex justify-content-center align-items-center gap-3 py-3 delete-button-responsive">
                            <button
                                onClick={handleActivateClose}
                                className="btn btn-light px-5"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleCampaignsSwitch}
                                
                                className={`btn ${isExecute ? "btn-success" : "btn-danger"} px-4`}
                            >
                                
                                {isExecute ? "Execute Now" : "Cancel Campaign"}
                            </button>
                        </div>
                    </div>
                </>
            </Modal>
            <div className='min-vh-100 m-4'>
                <div className="d-flex justify-content-between align-items-center header-responsive">
                    <h5 className='fw-semibold m-0'>Notification Campaigns</h5>
                    <button onClick={handleCampaignsShow} className='btn btn-light' > <Add /> Add New Campaign  </button>
                </div>
                <div className='row  align-items-center justify-content-end '>


                    <div className='col-md-6 col-sm-12 justify-content-end d-flex gap-2 my-3 input-group-responsive'>
                        <div className="w-100 d-flex align-items-center justify-content-end position-relative ">
                          
                            <input
  className='w-100 py-2 ps-3 pe-5 rounded-2 search-point'
  type="text"
  placeholder="Search campaign"
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
/>
<Search sx={{ color: " #535353", position: "absolute" }} />


                        </div>
                        <button onClick={handleClick} className='btn btn-light'>        <Tune /></button>


                        <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
                            <ClickAwayListener onClickAway={handleClose}>
                                <Paper sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2, minWidth: 200 }}>

                                    <FormGroup>
                                        {["Completed", "Processing", "Scheduled", "Draft","Cancelled","Failed"].map((item) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        icon={<CircleOutlinedIcon sx={{ fontSize: 15 }} />}
                                                        checkedIcon={<CircleIcon sx={{ color: "black", fontSize: 15 }} />}
                                                       checked={statusFilters.includes(item)}
                                                        onChange={() => handleStatusToggle(item)}
                                                    />
                                                }
                                                label={item}
                                            />
                                        ))}
                                    </FormGroup>

                                </Paper>
                            </ClickAwayListener>
                        </Popper>
                    </div>

                </div>
                <div className='data-grid-small'>
                    <Paper sx={{ height: "auto", width: "100%" }}>
                        <DataGrid
                            autoHeight
                            rows={filteredCampaigns}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            sx={{ border: 0 }}
                            checkboxSelection
                        />
                    </Paper>
                </div>
            </div>
        </>

    )
}

export default NotificationCampaigns